/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Orders_Estes_Pickup_Cancelled_SuccessInputs */

const en_orders_estes_pickup_cancelled_success = /** @type {(inputs: Orders_Estes_Pickup_Cancelled_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estes pickup cancelled for ${i?.count} order(s)`)
};

const es_orders_estes_pickup_cancelled_success = /** @type {(inputs: Orders_Estes_Pickup_Cancelled_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Recoleccion de Estes cancelada para ${i?.count} pedido(s)`)
};

/**
* | output |
* | --- |
* | "Estes pickup cancelled for {count} order(s)" |
*
* @param {Orders_Estes_Pickup_Cancelled_SuccessInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_estes_pickup_cancelled_success = /** @type {((inputs: Orders_Estes_Pickup_Cancelled_SuccessInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Estes_Pickup_Cancelled_SuccessInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_estes_pickup_cancelled_success(inputs)
	return es_orders_estes_pickup_cancelled_success(inputs)
});